import { render } from "./BusinessActivity.vue?vue&type=template&id=04dc4ac0&scoped=true"
import script from "./BusinessActivity.vue?vue&type=script&lang=js"
export * from "./BusinessActivity.vue?vue&type=script&lang=js"

import "./BusinessActivity.vue?vue&type=style&index=0&id=04dc4ac0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dc4ac0"]])

export default __exports__